// const SHOWRESULT = 'SHOWRESULT'
const SETISURSLOGIN = 'SETISURSLOGIN'
const SETUSERADDRESS = 'SETUSERADDRESS'
const SETUSERNAME = 'SETUSERNAME'
const SETORDERID = 'SETORDERID'
import Vue from 'vue'

export default {
  // 隐藏home显示container
  [SETISURSLOGIN](state, str) {
    state.isURSLogin = str
  },
  [SETUSERADDRESS](state, str) {
    state.userAddress = str
  },
  [SETUSERNAME](state, str) {
    state.username = str
  },
  [SETORDERID](state, str) {
    state.orderId = str
  },

  SETFISSIONDATA(state, data) {
    Vue.set(state, 'fissionData', data)
  },
  SETLOGINSTATUS(state, data) {
    Vue.set(state, 'ifNeedLogin', data)
  },
  FISSIONLOGINCHECK(state, data) {
    Vue.set(state, 'ifNeedGoExperience', data)
  },

  SETCONVERSIONDATA(state, data) {
    if (!state.activityData) {
      // 活动数据
      Vue.set(state, 'activityData', {})
    }
    Vue.set(state, 'activityData', {
      conversionData: data
    })
  },
  SETCONVERSIONLOGINSTATUS(state, data) {
    Vue.set(state, 'ifNeedConversionLogin', data)
  },
  SETCONVERSIONHASLOGIN(state, data) {
    Vue.set(state, 'ifConversionHasLogin', data)
  },
  SETORDERADDRESS(state, data) {
    state.orderAddress = data
  }
}
